<template>
	<section
		v-if="data && ((loadingPostsStatus === 'success' && postItems.length) || loadingPostsStatus === 'loading')"
		class="module-people margin-bottom-lg margin-top-lg"
	>
		<div class="container margin-auto margin-both-lg">
			<div class="heading-mod margin-bottom-sm">
				<h2 v-if="moduleTitle" class="module-title">{{ moduleTitle }}</h2>
			</div>
			<PostsGrid v-if="loadingPostsStatus === 'success' && postItems && postItems.length" :posts="postItems" />
		</div>
	</section>
</template>

<script>
import DummyLine from '@/components/elements/DummyLine'
import PostsGrid from '@/components/parts/PostsGrid'
import { mapOrder } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'
// I WISH TO HAVE TIME TO REBUILD WHOLE CRAP!!!!! AAAGGAAA
export default {
	name: 'posts-module',
	props: ['data'],
	data() {
		return {
			archiveLinkShow: true,
			postType: 'person',
			postItems: [],
			loadingPostsStatus: 'loading',
		}
	},
	components: {
		DummyLine,
		PostsGrid,
	},
	mounted() {
		const VM = this
		if (!VM.data) return false

		if (VM.selecedPeople) {
			VM.loadPosts({
				type: VM.postType || 'post',
				include: VM.selecedPeople,
				exclude: VM.exclude,
				limit: VM.selecedPeople.length,
			})
		}
	},
	computed: {
		...mapGetters(['currentPageID']),
		moduleTitle() {
			return this.data.title || this.data.module_title
		},
		selecedPeople() {
			if (!this.data.select_people) return []
			return this.data.select_people
		},
	},

	methods: {
		...mapActions(['getPost']),
		loadPosts(options = {}) {
			const VM = this
			VM.loadingPostsStatus = 'loading'
			return VM.getPost(options).then((res) => {
				if (res.data && res.data.posts && res.data.posts.length) {
					if (VM.selecedPeople) {
						VM.postItems.push(...mapOrder(res.data.posts, VM.selecedPeople, 'id'))
					} else {
						VM.postItems.push(...res.data.posts)
					}
				}
				VM.loadingPostsStatus = 'success'
				return VM.loadingPostsStatus
			})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.module-posts {
}
</style>
